module.exports = __webpack_public_path__ + "img/jumping-girl.57faaf0c.png";